import React from "react";
import "./ContactUsPage.css";
import { MdEmail, MdPhone } from "react-icons/md";

const ContactUsPage = () => {
  return (
    <section className="contact-page">

      {/* HEADER */}
      <div className="contact-header">
        <h1>Contact Us</h1>
        <div className="divider"></div>
        <p>We’d love to hear from you. Reach out anytime!</p>
      </div>

      {/* MAIN CONTENT */}
      <div className="contact-content">

        {/* LEFT SIDE - CONTACT METHODS */}
        <div className="contact-cards">

          {/* EMAIL */}
          <div className="contact-card">
            <div className="icon-wrapper">
              <MdEmail />
            </div>
            <h3>Email</h3>
            <p>
              <a href="mailto:office@amplehouse.net">
                office@amplehouse.net
              </a>
            </p>
          </div>

          {/* PHONE */}
          <div className="contact-card">
            <div className="icon-wrapper">
              <MdPhone />
            </div>
            <h3>Telephone</h3>
            <p>
              <a href="tel:+233 256 687 881">+233 256 687 881</a><br />
              
            </p>
          </div>

        </div>

        {/* RIGHT SIDE - MESSAGE PANEL */}
        <div className="contact-message">
          <h2>Let’s Connect</h2>
          <p>
            Whether you have a question, a partnership idea, or simply want to learn more about Ample House,
            we’re here to listen. Reach out and let’s start a meaningful conversation.
          </p>
        </div>

      </div>

    </section>
  );
};

export default ContactUsPage;